export const GET_LENDER_DECISIONS = 'GET_LENDER_DECISIONS';
export const GET_LENDER_DECISIONS_SUCCESS = 'GET_LENDER_DECISIONS_SUCCESS';
export const GET_LENDER_DECISIONS_FAILURE = 'GET_LENDER_DECISIONS_FAILURE';
export const LENDER_DECISIONS_REQUEST_SKIPPED = 'LENDER_DECISIONS_REQUEST_SKIPPED';
